import { Button } from '@fozito/common-ui';
import { AutoComplete, Col, Form, Input, InputRef, Row } from 'antd';
import InputPhone from 'components/MaskedInputs/InputPhone';
import DollarInputPayment from 'modules/POS/Cashier/components/DollarAmount/DollarInputPayment';
import { Ref } from 'react';
import styled from 'styled-components';
const bankNameOptions = [
  { value: 'Wells Fargo' },
  { value: 'PNC Bank' },
  { value: 'Capital One Bank' },
  { value: 'Chase Bank' },
];
type Props = {
  disabledAmount?: boolean,
  inputRef: Ref<InputRef>,
  onClose?: () => void;
};
const InfoForm = ({ inputRef, disabledAmount, onClose }: Props) => {
  return (
    <InfoFormStyled className='v2'>
      <Form.Item noStyle name={'routingNumber'} />
      <Form.Item noStyle name={'accountNumber'} />
      <Form.Item label='Customer' name={'name'}  >
        <Input
          placeholder='Please enter'
        />
      </Form.Item>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label='Phone' name={'phone'}  >
            <InputPhone placeholder='Please enter' />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label='Address' name={'address'}  >
            <Input
              placeholder='Please enter'
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label='Amount' name={'amount'}  >
        <DollarInputPayment withForm disabled={disabledAmount} />
      </Form.Item>
      <WrapperCheckInformation className={'v2'}>
        <div className="check-title">CHECK INFORMATION</div>
        <Row className='row-item' gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label='Pay To The Order Of' name={'companyName'}  >
              <Input
                placeholder='Please enter'
              />
            </Form.Item>

          </Col>
          <Col span={12}>
            <Form.Item label='No.' name={'no'} rules={[{ required: true }]} >
              <Input
                ref={inputRef}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                placeholder='0'
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className='row-item' gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label='Bank' name={'bankName'} >
              <AutoComplete
                options={bankNameOptions}
                filterOption={(inputValue, option) =>
                  option?.value?.toUpperCase()?.indexOf(inputValue.toUpperCase()) !== -1
                }
                popupClassName={'dropdown-v2'}
                placeholder='Select/Input'
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label='For' name={'bankFor'} >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row className='row-item' gutter={[16, 16]}>
          <Col span={8}>
            <Form.Item label='DL#' name={'dlInformation'} >
              <Input
                placeholder='0'
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='Routing Number' name={'routingNumber'} >
              <Input
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                placeholder='0'
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='Account Number' name={'accountNumber'} >
              <Input
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                placeholder='0'
              />
            </Form.Item>
          </Col>
        </Row>
      </WrapperCheckInformation>
      <WrapperRow>
        <Button type_cancel block onClick={onClose}>Cancel</Button>
        <Button type_primary block type='submit'>Ok</Button>
      </WrapperRow>
    </InfoFormStyled>
  );
};

export default InfoForm;

const WrapperRow = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  background: #FFF;
  margin: 0 -16px;
  box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.15);
  button {
    flex: 1;
  }
`;

const InfoFormStyled = styled.div`
padding: 16px;
padding-bottom: 0;
display: flex;
flex-direction: column;

.ant-input, .ant-input-suffix, .ant-input-number, .ant-select {
  height: 3rem;
  width: 100%;
}
.ant-input-number-handler-wrap {
  display: none;
}
.ant-input-number-input-wrap {
  height: 100%;
  input { 
    height: 100%;
  };
}

&.v2 {
  .ant-input, .ant-input-suffix, .ant-input-number, .ant-select, input.CurrencyInput {
    height: 4rem;
    width: 100%;
  }
  .ant-form-item .ant-form-item-label label {
    color: #1D2129;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .ant-form-item .ant-form-item-control .ant-form-item-control-input-content {
    .ant-select-selection-placeholder, input {
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
    .dollar-input-selector  {
      height: 4rem;
      padding: 0px 11px;
    }
    .dollar-input-selector .dollar-input-text {
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
}
`;

const WrapperCheckInformation = styled.div`
  margin: -16px;
  margin-bottom: 0px;
  .check-title {
    display: none;
  }
  &.v2 {
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    background: #FFF;
    .row-item {
      align-self: stretch;
    }
    .check-title {
      display: flex;
      align-self: stretch;
      color: #000;
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-bottom: 24px;
    }
  }
`;

